/*@ngInject*/
const UIPopupPositionDirective = function ($window, $timeout) {

    let linkFunction = function ($scope, $elm) {

        let timeoutList = [],
            appWindow = angular.element($window),
            toggleButton = $elm.find('.toggleCalendarPopup'),
            popupWidth = 247,
            offsetLeft = ($elm.offset().left + popupWidth),
            windowWidth = appWindow.width();

        $scope.setPopupPosition = function () {
            let popup = $elm.find('.componentDateTimePickerPopup'),
                right = windowWidth - offsetLeft;

            if (right < 0) {
                popup.addClass('popupAlignRight');
            } else {
                popup.removeClass('popupAlignRight');
            }
        };

        toggleButton.on('click.uiPopupPosition', function () {
            timeoutList.push($timeout(function () {
                $scope.setPopupPosition();
            }));
        });

        appWindow.on('resize.uiPopupPosition', function () {
            windowWidth = appWindow.width();
        });

        $scope.$on('$destroy', function () {
            appWindow.off('resize.uiPopupPosition');
            toggleButton.off('click.uiPopupPosition');

            _.each(timeoutList, function (item) {
                $timeout.cancel(item);
            });
        });
    };

    return {
        restrict: 'A',
        link: linkFunction
    };
};

angular.module('umFormViewer')
    .directive('uiPopupPosition', UIPopupPositionDirective);
